import Cookies from 'js-cookie'
import Helpers from './Helpers'
import Map from '../modules/Map'
class Shortlist {
    constructor() {

    }

    list() {
        if (Cookies.get('shortlist') !== undefined) {
            return Cookies.get('shortlist').split(",").filter(code => code.length > 0)
        } else {
            return []
        }
    }

    set(list) {
        Cookies.set('shortlist', list.join(","), { expires: 365 })
        this.updateHeaderIcon()
    }

    clear() {
        Cookies.remove('shortlist')
        this.updateHeaderIcon()
    }

    add(code) {
        if (!this.contains(code)) {
            let list = this.list()
            list.push(code.replace(/[CX]/, ''))
            this.set(list)
            window.dataLayerQueue.push({ 'event': 'addToShortlist', 'cottageCode': code });
        }
    }

    remove(code) {
        if (this.contains(code)) {
            let list = this.list()
            this.set(list.filter((c) => c.replace(/[CX]/, '') != code.replace(/[CX]/, '')))
        }
    }

    toggle(code) {
        if (!this.contains(code)) {
            this.add(code)
        } else {
            this.remove(code)
        }
    }

    contains(code) {
        return this.list().map(value => value.replace(/[CX]/, '')).indexOf(code.replace(/[CX]/, '')) >= 0
    }

    updateHeaderIcon() {
        const highlightClass = 'header__favourites--active'
        const icon = document.getElementsByClassName('header__favourites')
        if (this.list().length > 0) {
            new Helpers(icon).addClass(highlightClass)
        } else {
            new Helpers(icon).removeClass(highlightClass)
        }
    }
}

const shortlist = new Shortlist()
new Helpers(document.getElementsByClassName('set-item')).eventListener((e) => {
    if (e.target.getAttribute('data-inlist') === true) {
        window.sl.DeleteCottageFromShortList(e.target.getAttribute('data-code'), e.target.getAttribute('data-guid'))
        e.target.setAttribute('data-active', 'false')
    }
})

// Pageload - set cottage shortlist button states
const favouriteButtons = () => Array.from(document.querySelectorAll('.favourite-button'))

if (typeof Cookies.get('auth') === 'undefined') {
    favouriteButtons().forEach((el) => {
        el.setAttribute('data-multi', 'false')
        el.setAttribute('data-active', shortlist.contains(el.getAttribute('data-code')))
    })
}

// Favourite button click events
new Helpers(document.getElementsByTagName('body')).delegateEventListener('.favourite-button', (e) => {
    // don't react if we're not in "cookie shortlist" mode as that behaviour is handled by the shortlistapi
    if (e.target.getAttribute('data-multi') !== 'false') return

    const cottageCode = new Helpers(e.target).getClosest('[data-code]').getAttribute('data-code')
    const isShortlisted = (e.target.getAttribute('data-active') || 'false') == 'true'
    const affectedButtons = favouriteButtons().filter(button => button.getAttribute('data-code') === cottageCode)

    if (isShortlisted) {
        shortlist.remove(cottageCode)
        new Helpers(affectedButtons).setAttributes({ 'data-active': 'false' })
    } else {
        shortlist.add(cottageCode)
        new Helpers(affectedButtons).setAttributes({ 'data-active': 'true' })
    }
})

// My Shortlist
if (document.getElementsByClassName('shortlist__map').length) {
    const map = new Map('shortlistMap', {
        center: [50.1016, -5.2750],
        scrollWheelZoom: false,
    })

    const icon = L.icon({
        iconUrl: '/media/map/icon-home.png',
        iconSize: [33, 47],
        iconAnchor: [17, 46],
        popupAnchor: [0, -40],
    })

    const loadMarkers = () => {
        map.clearMarkers()
        Array.from(document.getElementsByClassName('results-list__item')).forEach((item) => {
            const lat = item.getAttribute('data-lat')
            const lng = item.getAttribute('data-lng')
            const title = item.getElementsByTagName('h2')[0].innerText
            map.addMarker([lat, lng], {
                title,
                icon,
            })
        })
        map.clusterMarkers()
        map.fitMarkers({ padding: [40, 40] })
    }

    loadMarkers()

    new Helpers(document.getElementsByTagName('body')).eventListener(() => {
        loadMarkers()
    }, 'shortlist.remove')

    new Helpers(document.getElementsByClassName('shortlist__main')).delegateEventListener('[aria-label="Favourite"][data-multi="false"]', (e) => {
        const item = new Helpers(e.target).getClosest('.results-list__item')
        item.parentElement.removeChild(item)
        loadMarkers()
    })

    new Helpers(document.getElementsByClassName('shortlist__clear')).eventListener((e) => {
        if (typeof Cookies.get('auth') !== 'undefined') {
            if (document.getElementsByClassName('shortlists-item').length > 0) {
                const shortlistId = document.querySelector('.shortlists-item[aria-current="true"]').getAttribute('data-shortlistid')
                window.sl.DeleteShortlist(shortlistId).then(() => {
                    window.location.replace('/my-classic/myshortlist.aspx')
                })
            }
        } else {
            Array.from(document.getElementsByClassName('shortlist__main')).forEach((item) => {
                item.parentElement.removeChild(item)
            })
            shortlist.clear()
        }
        loadMarkers()
    })
}

export default Shortlist
